module.exports = __webpack_public_path__ + "static/img/portrait2.f447f229.webp";